import React from 'react'
import Footer from '../Footer'
import Header from '../Header'
import Newsletter from '../Newsletter'
import Team from '../Team'

const Teampage = () => {
  return (
    <>

        <Header />
        <Team />
        <Newsletter />
        <Footer />
      
    </>
  )
}

export default Teampage
